import { TokenPairDto } from "../services/auth/restModels";

const TOKEN_STORAGE_KEY = "token";

export const getToken = () => {
    const stored = localStorage.getItem(TOKEN_STORAGE_KEY);

    if (!stored) return "";

    return (JSON.parse(stored) as TokenPairDto).authToken;
};


export const removeTokenPair = () => {
    localStorage.removeItem(TOKEN_STORAGE_KEY);
};


export const saveRestTokenPair = (token: TokenPairDto) => {
    if (!token) return;

    localStorage.setItem(TOKEN_STORAGE_KEY, JSON.stringify(token));
};

export const saveAuthToken = (authToken: string) => {
    saveRestTokenPair({ authToken, authTokenExpiresAt: 0 });
};
